import mock from './mock'
// import './user'

mock.onAny().passThrough()
